import { toResponseError, type QuizRemoveInput, type QuizRemoveSuccess } from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { mutationRemove, type RemoveHookResponse } from '../hooks'
import { useQuizCache } from './cache'

export function useRemoveQuiz(): RemoveHookResponse<QuizRemoveInput> {
  const mutation = useTantalimMutation<QuizRemoveInput, QuizRemoveSuccess>({
    url: '/quiz/remove',
  })
  const cache = useQuizCache()

  async function remove(input: QuizRemoveInput): Promise<void> {
    try {
      await mutation.mutateAsync(input)
      cache.clearList()
      cache.clearItem(input.quizId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
